
























import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { ImagePreview } from 'vant'
import { ref } from '@vue/composition-api'

export default defineClassComponent(
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 当前轮播项索引
      current = ref(0)

      // 轮播项改变时触发
      handleChange = (index: number) => {
        this.current.value = index
      }

      // 点击轮播项
      handleClick = (index: number) => {
        if (this.goodsData.value.carousePic[index].endsWith('.mp4')) return
        ImagePreview({
          images: this.goodsData.value.carousePic,
          startPosition: index,
        })
      }
    },
)
